import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ToastService } from 'app/core/services/toast/toast.service';

@Component({
    selector: 'app-file-btn',
    templateUrl: './file-btn.component.html',
    styleUrls: ['./file-btn.component.scss'],
    standalone: true
})
export class FileBtnComponent {
  fileName: string;
  /** flag for tooltip */
  @Input() showTooltip = true;
  /** button text to display */
  @Input() buttonText = 'Cargar';
  /** style for the button */
  @Input() btnStyleClasses = 'btn-info btn-sm text-bold-300 px-1 py-1';
  /** name of the input element */
  @Input() name: string;
  /** type of files accepted */
  @Input() accept = '*';

  /** event on send file */
  @Output() sendFile = new EventEmitter<File>();

  constructor(private toastService: ToastService) {
  }

  openFileBrowser(event: any): void {
    event.preventDefault();
    const element: HTMLElement = document.getElementById(this.name) as HTMLElement;
    element.click();
  }

  onFileChange(event): void {
    let file = event.target.files[0];
    if (file.size > 2000000) {
      file = undefined;
      return this.toastService.danger('El tamaño máximo permitido es 2MB');
    }
    this.fileName = file.name;

    this.sendFile.emit(file);
  }

}
